import React, {Component} from 'react'
import Elm from 'react-elm-components'
import config from '../../../lib/config'
import MyElmComponent from '../../../elm/src/ShowDocumentsCard.elm'

export default class ShowDocumentsCard extends Component {
    render() {
        const {simplifiedRequest, ticket} = this.props
        const sr = {simplifiedRequestUid: simplifiedRequest || null}
        const flags = {
            ...sr,
            entityUid: ticket,
            queryApiBaseUrl: config.api.url
        }
        return (
            <div><Elm src={MyElmComponent.Elm.ShowDocumentsCard} flags={flags}/></div>
        )
    }
}


// WEBPACK FOOTER //
// ./lib/ticket/components/ShowDocumentsCard.js